<template>
  <div>
    <div class="results-page" v-if="answerData">
      <div class="bg"></div>
      <div class="content">
        <img
          class="results"
          src="./../../assets/microscope/results.png"
          alt=""
        />
        <div class="topTitle">恭喜您已完成显微镜操作判读的全部考核!</div>
        <div class="pic">{{ answerData.score }}</div>
        <div class="pictxt">您的总成绩</div>
        <div class="pictxtall">(满分100分)</div>
        <div class="explain">所有显微镜</div>
        <div class="explain">操作判读考核的答案即时查看！</div>
        <div class="detail">
          <img
            class="detailIcon"
            src="./../../assets/microscope/detailIcon.png"
            alt=""
          />
          得分详情
        </div>
        <div class="flex">
          <div class="left">
            <div class="top">玻片1考核：{{ answerData.slide1Score }}分</div>
            <!-- <div class="bottom">
              低倍镜考核：{{ answerData.slide1LowScore }}分
            </div> -->
            <div class="bottom">
              高倍镜下结果判读：{{ answerData.slide1HighScore }}分
            </div>
          </div>
          <div class="right">
            <div class="top">玻片2考核：{{ answerData.slide2Score }}分</div>
            <!-- <div class="bottom">
              低倍镜考核：{{ answerData.slide2LowScore }}分
            </div> -->
            <div class="bottom">
              高倍镜下结果判读：{{ answerData.slide2HighScore }}分
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div @click="handleBtn" class="btn">确认</div>
        <!-- <div @click="handleGoAnswer" class="btns">查看答案</div> -->
      </div>
      <div class="mask" v-if="isShow"></div>
      <div class="dialog" v-if="isShow">
        <div class="text mt100">敬请期待</div>
        <!-- <div class="text">8.1号可查看</div> -->
		<div class="text">暂未开放</div>
        <div class="flex">
          <div @click="handleClose" class="btn">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSlideScore, isEnd } from "@/api/system/exam";
export default {
  data() {
    return {
      answerData: null,
      isEnd: false,
      isShow: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.handleBtn, false);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.handleBtn, false);
  },
  methods: {
    // 回首页
    handleBtn() {
      // this.$router.replace({
      //   path: "/index/home2026",
      //   query: { isLogin: false },
      // });
      this.$router.replace({
        path: "/microscope/transfer",
      });
    },

    // 去答案页
    handleGoAnswer() {
      // this.$router.push('/microscope/Online')
      if (this.isEnd) {
        this.$router.push("/microscope/Online");
        // this.$router.replace('/microscope/Online')
      } else {
        this.isShow = true;
      }
    },

    // 关闭确认弹框
    handleClose() {
      this.isShow = false;
    },

    // 初始化
    init() {
      isEnd().then((res) => {
        if (res.data.code === 0) {
          this.isEnd = res.data.data;
        }
      });
      getSlideScore().then((res) => {
        if (res.data.code === 0) {
          this.answerData = res.data.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.results-page {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/home/cbbj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .bg {
    height: 90px;
  }
  .content {
    width: 653px;
    height: 1239px;
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border: 2px solid #ffffff;
    border-radius: 60px;
    margin: 0 auto;
    padding-top: 80px;
    margin-bottom: 150px;
    .results {
      display: block;
      width: 109px;
      margin: 0 auto;
    }
    .topTitle {
      font-size: 30px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #333333;
      text-align: center;
      margin-top: 46px;
    }
    .pic {
      width: 375px;
      height: 375px;
      background: rgba(0, 173, 163, 0.7);
      border-radius: 50%;
      line-height: 375px;
      text-align: center;
      font-size: 157px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #ffffff;
      margin: 0 auto;
      margin-top: 50px;
    }
    .pictxt {
      margin-top: 28px;
      font-size: 30px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #333333;
      text-align: center;
    }
    .pictxtall {
      margin-bottom: 60px;
      font-size: 30px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #333333;
      text-align: center;
    }
    .explain {
      font-size: 30px;
      font-family: HarmonyOS Sans SC;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }
    .detail {
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #333333;
      margin: 60px 0 40px 32px;
      .detailIcon {
        width: 28px;
        vertical-align: middle;
        margin-top: -5px;
      }
    }
    .flex {
      display: flex;
      margin: 0 32px;
      .left,
      .right {
        .top {
          font-size: 25px;
          font-family: HarmonyOS Sans SC;
          font-weight: bold;
          color: #ab3b91;
        }
        .bottom {
          font-size: 25px;
          font-family: HarmonyOS Sans SC;
          font-weight: bold;
          color: #4c4c4c;
        }
      }
      .right {
        margin-left: auto;
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    width: 570px;
    height: 143px;
    background: linear-gradient(0deg, #ffffff, #e9f4f2);
    box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
    border-radius: 60px 60px 0px 0px;
    padding: 40px 90px 0 90px;
    display: flex;
    .btn {
      width: 308px;
      height: 87px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      line-height: 88px;
      border-radius: 44px;
      font-size: 35px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      margin-right: 50px;
      margin: 0 auto;
    }
    .btns {
      width: 310px;
      height: 87px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      line-height: 88px;
      border-radius: 44px;
      font-size: 35px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
    }
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(255, 255, 255, 0.8);
  }
  .dialog {
    width: 665px;
    height: 480px;
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: #ffffff;
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border-radius: 60px;
    .title {
      height: 60px;
      font-size: 65px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #ab3b91;
      text-align: center;
      margin-top: 100px;
    }
    .text {
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #333333;
      line-height: 60px;
      text-align: center;
    }
    .mt100 {
      margin-top: 100px;
    }
    .flex {
      display: flex;
      padding: 120px 50px 0 50px;
      .btn {
        width: 260px;
        margin: 0 auto;
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-size: 35px;
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        color: #ffffff;
        border-radius: 40px;
        background: linear-gradient(
          132.74deg,
          rgba(0, 187, 177, 1) 0%,
          rgba(0, 86, 140, 1) 74.31%,
          rgba(171, 59, 127, 1) 100%
        );
      }
    }
  }
}
</style>
